import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Select.module.scss';

function Select(props) {
  const { disabled, value } = props;

  const [error, setError] = useState({
    isError: false,
    message: '',
  });

  const handleChange = (event) => {
    if (!disabled) {
      props.onChange(event.target.value);
      validate(event.target.value);
    }
  };

  const validate = (value) => {
    props.validate.some((validator) => {
      const result = validator(value);
      setError(result);

      // break (return true) if doesn't pass validation
      return result.isError;
    });
  };

  const options = props.options.map((option) => (
    <option value={option.value} key={option.value}>
      {option.label}
    </option>
  ));

  return (
    <div
      className={cn(
        styles.container,
        error.isError && !disabled ? ' ic-warning' : '',
        error.isError && !disabled ? styles.error : '',
        disabled ? styles.disabled : '',
        props.inline ? styles.inline : '',
      )}
    >
      <select
        name={props.name}
        value={value}
        onChange={handleChange}
        className={error.isError ? styles.error : ''}
        onBlur={props.blur ? handleChange : null}
        disabled={disabled}
        data-testid={props.testId || 'select-input'}
      >
        {options}
      </select>
    </div>
  );
}

export default Select;

Select.defaultProps = {
  options: [],
  blur: false,
  validate: [],
  name: '',
  disabled: false,
  value: '',
  inline: false,
};

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  validate: PropTypes.arrayOf(PropTypes.func),
  blur: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  inline: PropTypes.bool,
};
